import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { Timezone } from '../timezone.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class TimezonesResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient) {}

  query(params?: QueryParams): Observable<Timezone[]> {
    return this.http.get<Timezone[]>(`${this.apiRoot}/timezones`, { params });
  }
}

((window as any).xplenty as angular.IModule).service('Timezone', downgradeInjectable(TimezonesResource));
